import { type AddressDto, LandmarkReasonDto } from '@/types';
import { hasValidLandmarkType, isPrivateBuilding } from '@/utils/tripAddress';
import type { Address, WellKnownPlace } from '@/types/customer/address.types';

export default function toAddress(address: AddressDto): Address {
  let place: WellKnownPlace | null = null;

  if (isPrivateBuilding(address.place)) {
    place = address.place;
  } else if (address.place !== null) {
    place = Object.assign({}, {
      name: address.place.name,
      type: hasValidLandmarkType(address.place.type)
        ? address.place.type
        // Valeur par défaut (pin bleue).
        : 'LOISIRS',
      isMedical: hasLandmarkReason(address.place.tripReason) && address.place.tripReason === LandmarkReasonDto.Medical,
      note: address.place.note,
    });
  }

  return {
    ...address,
    isPrivate: isPrivateBuilding(place) || place === null,
    place,
    coordinateWgs84: address?.coordinateWgs84 ?? null,
  };
}

/** type-guard: Valide que la "raison" fournie dans la place publique soit supportée */
function hasLandmarkReason(key: string): key is LandmarkReasonDto {
  return !!Object.values(LandmarkReasonDto).find(reason => reason === key);
}
